import React from 'react';
import ReactDOM from 'react-dom';
import { get } from 'lodash';

import App from '../../universal/app/components/App';
import { MESSAGE_BUS_TOPICS } from '../../universal/constants';

const init = () => {
    const getBreadcrumbsConfig = () => {
        const {
            breadcrumbConfig: {
                breadcrumbElements,
                pageTitle,
                events,
                eventId,
                sportName,
                locale,
                competitionName,
                tokens,
                pathName,
            },
            translations,
            platform,
        } = get(window, 'breadcrumbsV2Data.configuration');
        return {
            translations,
            platform,
            breadcrumbElements,
            pageTitle,
            events,
            eventId,
            sportName,
            locale,
            competitionName,
            tokens,
            pathName,
        };
    };
    let appReference;

    const getTargetElement = () => document.getElementById('breadcrumbsV2');

    const render = (Component) => {
        appReference = getTargetElement();

        appReference && ReactDOM.render(<Component {...getBreadcrumbsConfig()} />, appReference);
    };

    render(App);

    window.WH.messageBus.subscribe(MESSAGE_BUS_TOPICS.NAVIGATION_PAGE_CHANGED, () => {
        appReference && ReactDOM.unmountComponentAtNode(appReference);
        render(App);
    });

    if (module.hot) {
        module.hot.accept('../../universal/app/components/App', () => {
            // eslint-disable-next-line global-require
            const NextAppComponent = require('../../universal/app/components/App').default;
            render(NextAppComponent);
        });
    }
};

init();

if (module.hot) {
    module.hot.accept();
}
